<template>
  <section class="hero-section">
    <div class="container">
      <div class="nav-tabs">
        <button
          v-for="tab in navTabs"
          :key="tab.id"
          :class="['nav-tab', { active: activeTab === tab.id }]"
          @click="switchTab(tab.id)"
        >
          <span class="tab-icon">{{ tab.icon }}</span>
          <span class="tab-text">{{ tab.name }}</span>
        </button>
      </div>

      <h1 class="hero-title">{{ title }}</h1>
      <p class="hero-subtitle">{{ subtitle }}</p>

      <div class="paste-link-container">
        <div class="input-group">
          <input
            v-model="instagramLink"
            type="text"
            class="link-input"
            :placeholder="inputPlaceholder"
          >
          <button class="paste-btn" @click="pasteFromClipboard">
            <span class="paste-icon">{{ pasteIcon }}</span>
            Paste
          </button>
          <button class="download-btn" @click="downloadContent">
            Download
          </button>
        </div>
      </div>

      <div class="action-buttons">
        <button class="download-app-btn" @click="goToDownload">
          <img src="@/assets/download.png" alt="Download" class="btn-icon">
          Download InstaSave App
        </button>
        <button class="telegram-btn" @click="joinTelegramChannel">
          <img src="@/assets/telegram-blue.png" alt="Telegram" class="btn-icon">
          Join our Telegram Channel
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    title: {
      type: String,
      default: 'InstaSave - Instagram Downloader'
    },
    subtitle: {
      type: String,
      default: 'Simply paste the Instagram link and click the download button'
    },
    inputPlaceholder: {
      type: String,
      default: 'Paste Instagram link here...'
    },
    activeTab: {
      type: String,
      default: 'video'
    }
  },
  data() {
    return {
      instagramLink: '',
      pasteIcon: '\u{1F4CB}',
      navTabs: [
        { id: 'video', name: 'Video', icon: '\u25B6', title: 'Instagram Video Download' },
        { id: 'photo', name: 'Photo', icon: '\u25A3', title: 'Instagram Photo Download' },
        { id: 'story', name: 'Story', icon: '\u2605', title: 'Instagram Story Download' },
        { id: 'reels', name: 'Reels', icon: '\u25A6', title: 'Instagram Reels Download' },
        { id: 'post', name: 'Post', icon: '\u25A4', title: 'Instagram Post Download' },
        { id: 'igtv', name: 'IGTV', icon: '\u25A0', title: 'Instagram IGTV Download' }
      ]
    }
  },
  methods: {
    switchTab(tabId) {
      this.$emit('tab-change', tabId);
      if (tabId === 'video') {
        this.$router.push('/video-downloader/');
      } else if (tabId === 'photo') {
        this.$router.push('/photo-downloader/');
      } else if (tabId === 'story') {
        this.$router.push('/story-downloader/');
      } else if (tabId === 'reels') {
        this.$router.push('/reels-downloader/');
      } else if (tabId === 'post') {
        this.$router.push('/post-downloader/');
      }
    },
    pasteFromClipboard() {
      if (navigator.clipboard && navigator.clipboard.readText) {
        navigator.clipboard.readText().then(text => {
          this.instagramLink = text;
        }).catch(err => {
          console.error('Failed to read clipboard contents: ', err);
        });
      }
    },
    downloadContent() {
      this.$emit('download-content', this.instagramLink);
    },
    goToDownload() {
      this.$emit('go-to-download');
    },
    joinTelegramChannel() {
      this.$emit('join-telegram');
    }
  }
}
</script>

<style scoped>
.hero-section {
  background: linear-gradient(80deg, #D009FF 0%, #3b82f6 100%);
  padding: 60px 20px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 50px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 8px;
  border-radius: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.nav-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  flex: 1;
  justify-content: center;
}

.nav-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-tab.active {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  font-weight: 600;
}

.tab-icon {
  font-size: 14px;
}

.tab-text {
  font-weight: inherit;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 600;
  color: white;
  margin-bottom: 20px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 0.9rem !important;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 50px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.paste-link-container {
  max-width: 600px;
  margin: 0 auto 20px;
}

.input-group {
  display: flex;
  gap: 0;
  background: white;
  padding: 4px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border: 1px solid rgba(0,0,0,0.05);
}

.link-input {
  flex: 1;
  padding: 16px 20px;
  border: none;
  outline: none;
  font-size: 15px;
  background: transparent;
  border-radius: 8px;
}

.link-input::placeholder {
  color: #9ca3af;
}

.paste-btn {
  padding: 12px 16px;
  background: #e5e7eb;
  color: #6b7280;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  margin-right: 4px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.paste-btn:hover {
  background: #d1d5db;
  color: #374151;
}

.paste-icon {
  font-size: 14px;
}

.download-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.download-btn:hover {
  background: #dc2626;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
}

.download-app-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.download-app-btn:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.telegram-btn {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 0 22px;
  height: min-content;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.telegram-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-2px);
}

.btn-icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .nav-tabs {
    gap: 6px;
    margin-bottom: 40px;
    padding: 6px;
    border-radius: 25px;
  }

  .nav-tab {
    padding: 8px 12px;
    font-size: 11px;
  }

  .input-group {
    flex-direction: column;
    gap: 8px;
    border-radius: 12px;
  }

  .paste-btn,
  .download-btn {
    width: 100%;
    justify-content: center;
  }

  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
